/* istanbul ignore file */
import { ComposedTheme, createUseStyles } from '@glu/theming';
import { IStyledTabProps } from './StyledTab';

type TStyleProps = Pick<IStyledTabProps, 'color'>;

const styles = ({
  palette,
  tabs: { badge, defaultTabBorder, defaultTabBorderColor, styledTab, tab },
}: ComposedTheme) => ({
  tab: {
    borderStyle: 'solid',
    borderColor: ({ color }: TStyleProps) => `${color || defaultTabBorder} 
    ${defaultTabBorderColor} ${defaultTabBorderColor} ${defaultTabBorderColor}`,
    borderRadius: [3, 3, 0, 0],
    padding: [10, 16, 5],
    verticalAlign: 'bottom',
    textAlign: 'left',
    cursor: 'pointer',
    display: 'inline-block',
    marginRight: '-1px',
    ...styledTab,
    '&:focus': {
      outlineColor: tab.focusColor,
    },
  },
  tabBorder: {
    borderWidth: ({ color }: TStyleProps) => (color ? '5px 1px 1px' : 1),
  },
  selected: {
    backgroundColor: palette.background,
    borderBottom: 'none',
    boxShadow: '0px -4px 9px -8px rgba(115,115,115,1);',
    position: 'relative',
    top: -4,
  },
  title: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: 16,
  },
  subtitle: {
    display: 'block',
    fontSize: 12,
  },
  badge: {
    textAlign: 'center',
    ...badge,
  },
  actionButton: {
    display: 'inline',
  },
  tabContent: {
    display: 'flex',
  },
  titleCol: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    minHeight: 35,
  },
  actionBadgeCol: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    minHeight: 35,
    padding: [0, 0, 0, 16],
  },
});

export default createUseStyles(styles);
